import React from "react";
import { observer } from "mobx-react";
import { DashboardLayoutTemplateViewStore } from "../../store";
import { DashboardLayoutTemplateViewForm } from "./DashboardLayoutTemplateViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type DashboardLayoutTemplateViewProps = {
  dashboardLayoutTemplateViewStore: DashboardLayoutTemplateViewStore;
};

export const DashboardLayoutTemplateView: React.FC<DashboardLayoutTemplateViewProps> =
  observer(({ dashboardLayoutTemplateViewStore }) => {
    return (
      <div>
        <DashboardLayoutTemplateViewForm
          name={dashboardLayoutTemplateViewStore.nameValue}
          forRole={dashboardLayoutTemplateViewStore.forRoleValue}
          widgets={dashboardLayoutTemplateViewStore.widgetsValue}
          isDefault={dashboardLayoutTemplateViewStore.isDefaultValue}
          enabled={dashboardLayoutTemplateViewStore.enabledValue}
          isForAllTenants={
            dashboardLayoutTemplateViewStore.isForAllTenantsValue
          }
          onPrint={(handlePrint: () => void) =>
            dashboardLayoutTemplateViewStore.printDashboardLayoutTemplate(
              handlePrint
            )
          }
          onCancel={() =>
            dashboardLayoutTemplateViewStore.cancelDashboardLayoutTemplate()
          }
          onEdit={
            dashboardLayoutTemplateViewStore.isEditEnabled
              ? () =>
                  dashboardLayoutTemplateViewStore.editDashboardLayoutTemplate()
              : undefined
          }
        />
        <ErrorDialog
          open={dashboardLayoutTemplateViewStore.errorDialogOpened}
          title={dashboardLayoutTemplateViewStore.errorTitle}
          description={dashboardLayoutTemplateViewStore.errorDescription}
          onClose={() => dashboardLayoutTemplateViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
